import script from "./HrIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./HrIcon.vue?vue&type=script&setup=true&lang=js"

import "./HrIcon.vue?vue&type=style&index=0&id=65e02761&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e02761"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
